import React from 'react'
import MonetizeIcon from '@material-ui/icons/MonetizationOn'
import Typography from '@material-ui/core/Typography'
import { FlexDataItem } from 'components/FlexDataView'
import {FormattedMessage} from 'react-intl'

export default props => {
  const ticker = props.allocation.ticker || 'Unit';
  return <FlexDataItem>
    <Typography variant='subtitle1'>
      <MonetizeIcon /><FormattedMessage id="allocation.section.rate" />
    </Typography>
    <dl>
      <dt><FormattedMessage id="allocation.section.rate.rate_label" /></dt>
      <dd>{props.allocation.rate} {ticker}/{props.allocation.currency.code}</dd>

      <dt><FormattedMessage id="allocation.section.rate.public_rate_label" /></dt>
      <dd>{props.allocation.publicSaleRate} {ticker}/{props.allocation.currency.code}</dd>
    </dl>
  </FlexDataItem>
}